export default function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-collection/src/entries.js
// module id = ../../../../d3-collection/src/entries.js
// module chunks = vendor